module.exports = __webpack_public_path__ + "img/checkboxEle.d15a4dab.svg";